import { Link } from 'react-router-dom';
import { footerGroups, siteInfo } from '@/mocks/site';
import SubscribeForm from '@/components/feature/SubscribeForm';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-8 pt-12 md:pt-16 pb-8">
        <div className="bg-background-50 border border-background-200 rounded-2xl p-6 md:p-8 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div className="max-w-md">
            <h2 className="text-xl md:text-2xl text-foreground-950">不错过任何一次福利上新</h2>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
              留下邮箱，新活动上线、奖励加码、抽奖开奖都会提前提醒，不用天天自己刷。
            </p>
          </div>
          <div className="w-full lg:max-w-md">
            <SubscribeForm />
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 cursor-pointer" aria-label={`${siteInfo.name} 首页`}>
              <span className="w-9 h-9 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-gift-2-fill"></i>
              </span>
              <span className="font-heading text-lg text-foreground-950">{siteInfo.name}</span>
            </Link>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">{siteInfo.intro}</p>
            <p className="mt-4 text-xs text-foreground-500">内容更新时间：{year} 年 · {siteInfo.updateNote}</p>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-medium text-foreground-950">{group.title}</h3>
              <ul className="mt-4 flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500 text-center sm:text-left">
            © {year} {siteInfo.name} · {siteInfo.slogan}
          </p>
          <p className="text-xs text-foreground-500 text-center sm:text-right">
            合作与反馈：{siteInfo.email} · {siteInfo.hours}
          </p>
        </div>
      </div>
    </footer>
  );
}